module.exports = __webpack_public_path__ + "media/images/favicon/favicon-b95ad78f4691e7d4920dce32421731ac.ico";